import { useNavigate } from "react-router-dom";

import { HoverCard, Table, Text } from "@mantine/core";

import { Pageable } from "../../models/Pageable.ts";
import { Template } from "../../models/Template.ts";
import { TableSkeleton } from "../skeletons/TableSkeleton.tsx";

export function TemplatesTable({
  templates,
  isLoading,
  currentPage,
  maxElementsPerPage
}: {
  templates: Pageable<Template>;
  isLoading: boolean;
  currentPage: number;
  maxElementsPerPage: number;
}) {
  const navigate = useNavigate();
  const openTemplateEdition = (template: Template) => {
    navigate(`/templates/${template.code}`, { state: { pageNumber: currentPage } });
  };
  return (
    <Table>
      <Table verticalSpacing="sm" highlightOnHover>
        <Table.Tbody>
          {isLoading ? (
            <TableSkeleton columnNumber={2} rowNumber={maxElementsPerPage} key="skeleton" />
          ) : (
            templates?.content.map((template) => (
              <Table.Tr key={template.id} onClick={() => openTemplateEdition(template)}>
                <Table.Td>
                  <Text size={"lg"}>{template.code}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size={"lg"}>{template.subject}</Text>
                </Table.Td>
                <Table.Td>
                  {template.overrideBody || template.overrideSubject ? (
                    <HoverCard width={280} shadow="md" openDelay={500}>
                      <HoverCard.Target>
                        <Text size={"lg"} c={"grey"}>
                          <i>Modified</i>
                        </Text>
                      </HoverCard.Target>
                      <HoverCard.Dropdown>
                        <Text size="sm">This template has been modified by an user.</Text>
                      </HoverCard.Dropdown>
                    </HoverCard>
                  ) : (
                    <></>
                  )}
                </Table.Td>
              </Table.Tr>
            ))
          )}
        </Table.Tbody>
      </Table>
    </Table>
  );
}
